import FormComponent from "./form-component";
import Input, { FormParams } from "./input";

export default function TextInput(params: FormParams) {
  return (
    <FormComponent
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <Input type="text" {...params} />
    </FormComponent>
  );
}
